export default function modal() {
  let modalBtn = jQuery('.modal-btn');
  let modalClose = jQuery('.modal-close');
  const careerAppliedField = jQuery('#field_xqswf');

  modalBtn.on('click', function (e) {
      e.preventDefault();
      let modalId = jQuery(this).data('modal');
      jQuery('.team-card-bio').fadeOut();
      jQuery('.share-tooltip').fadeOut();
      jQuery('#' + modalId).fadeIn();

      if (careerAppliedField.length) {
          careerAppliedField.val(jQuery(this).data('career-heading'));
      }
      e.stopPropagation();
  });

  modalClose.on('click', function () {
      let modalId = jQuery(this).data('modal-close');
      jQuery('#' + modalId).fadeOut();
  });

  jQuery(document).on('click', function (e) {
      if (jQuery(e.target).closest('.modal-inner').length === 0) {
          jQuery('.modal').fadeOut();
      }
  });

  jQuery(document).on('click', function (e) {
      if (jQuery(e.target).closest('.team-card-bio').length === 0) {
          jQuery('.team-card-bio').fadeOut();
      }
  });

  jQuery(document).on('click', function (e) {
      if (jQuery(e.target).closest('.share-tooltip').length === 0) {
          jQuery('.share-tooltip').fadeOut();
      }
  });
}
